import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import pickleball from "../assets/videos/pickleball.mov";
import './Common.css';


const PickleBall=()=>{
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return(
        <>
            <div className="page-container">
                <div data-aos="zoom-in" className="col-12 fw-bolder fs-1 text-white text-center m-5"><span className="gradient-text">Pickle Ball Game</span></div>
                <div className="row justify-content-around" >
                    <div className="col-12 col-md-4 p-0 rounded-5 d-flex justify-content-center align-items-end">
                        <div className="text-white fs-5">
                            
                            <p data-aos="fade-right" className="p-3 lead fs-4 fw-bold">
                                Pickleball is a fast-growing sport that combines elements of tennis, badminton, and table tennis. 
                                It is played with a paddle and a plastic ball with holes, on a court similar in size to a badminton court. 
                                The sport can be enjoyed by people of all ages and skill levels, making it a fantastic activity for both casual and competitive players.
                            </p>
                        </div>
                    </div>
                    <div className="col-11 col-md-4 p-0 rounded-5 position-relative d-flex justify-content-center align-items-end">
                        <video className="rounded-5 w-100 h-100 zindex-1" data-aos="zoom-in" autoPlay playsInline muted loop style={{objectFit:"cover"}}>
                            <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src={pickleball}>
                            </source>
                        </video>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PickleBall;